import { create } from "zustand";
import { authApi, type MeResponse } from "@/api/auth";
import { ApiError } from "@/api/types";

interface SessionState {
  user: MeResponse["user"] | null;
  env: MeResponse["environment"] | null;
  plan: MeResponse["plan"] | null;
  hydrating: boolean;
  hydrated: boolean;
  hydrate: () => Promise<void>;
  /** Force-refetch /me (ignores the hydrated guard). Used after billing changes. */
  refresh: () => Promise<void>;
  setSession: (m: MeResponse) => void;
  clear: () => void;
}

export const useSession = create<SessionState>((set, get) => ({
  user: null,
  env: null,
  plan: null,
  hydrating: false,
  hydrated: false,
  hydrate: async () => {
    if (get().hydrating || get().hydrated) return;
    set({ hydrating: true });
    try {
      const me = await authApi.me();
      set({ user: me.user, env: me.environment, plan: me.plan, hydrated: true, hydrating: false });
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) {
        set({ user: null, env: null, plan: null, hydrated: true, hydrating: false });
        return;
      }
      set({ hydrating: false });
      throw e;
    }
  },
  refresh: async () => {
    try {
      const me = await authApi.me();
      set({ user: me.user, env: me.environment, plan: me.plan, hydrated: true });
    } catch {
      /* keep the current session on a transient failure */
    }
  },
  setSession: (m) => set({ user: m.user, env: m.environment, plan: m.plan, hydrated: true }),
  clear: () => set({ user: null, env: null, plan: null, hydrated: true }),
}));
